






















import { Vue, Component } from "vue-property-decorator";
import { lockModule } from "@/store/lock";
import { Lock, GetLockLogsResult } from "@/../generated/iloq-api";
import router from "@/router";

@Component({
  components: {}
})
export default class Home extends Vue {
  currentLog: GetLockLogsResult | null = null;
  typeMask = {
    "0": "Unknown type",
    "1": "Failed access",
    "2": "Lock was programmed",
    "4": "Successful access",
    "8": "Phone accessed the lock",
    "16": "Fob accessed the lock",
    "1024": "Key accessed the lock",
    "2048": "5 Series key accessed the lock",
    "4096": "Unknown key (Key is empty or in factory state)",
    "8192": "Snap open access",
    "16384": "Log is a key passage from a lock which doesn't collect logs."
  };

  mounted() {
    if (this.sessionId) {
      router.push({ name: "Locks" });
    } else {
      router.push({ name: "Login" });
    }
  }

  fetchLockLog(lock: Lock) {
    if (lock.FLock_ID) {
      lockModule.fetchLockLog(lock.FLock_ID).then(response => {
        this.currentLog = response;
      });
    }
  }

  get sessionId() {
    return lockModule.sessionId;
  }

  get locks() {
    return lockModule.locks;
  }
}
